/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Go_Further_Dialog_ContactInputs */



/**
* | output |
* | --- |
* | "Email us at {email}" |
*
* @param {Go_Further_Dialog_ContactInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const go_further_dialog_contact = /** @type {((inputs: Go_Further_Dialog_ContactInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Go_Further_Dialog_ContactInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Email us at ${i?.email}`)
	return /** @type {LocalizedString} */ (`Écrivez-nous à ${i?.email}`)
});